<template>

  <div class="itemized-panel">
    <img :src="require(`@/assets/panel/${imgField}-2.png`)" class="bg">

    <div class="card">
      <div class="title">
        <img :src="require(`@/assets/panel/${imgField}-1.png`)" />
        {{detailData.typeText}}
      </div>
      <div class="main">
        <p class="desc" v-html='tips'></p>
        <div class="jg fx">
          <div class="left fx-none">
            <el-descriptions :column='1'>
              <el-descriptions-item :label="detailData.typeText+'评级'">
                <div class="value">{{data.grade||'--'}}级</div>
              </el-descriptions-item>
              <!-- <el-descriptions-item label="行业排名">
                <div class="value">{{detailData.rank||'--'}}级</div>
              </el-descriptions-item>
              <el-descriptions-item label="地区排名">
                <div class="value">{{detailData.regionRank||'--'}}级</div>
              </el-descriptions-item>-->
            </el-descriptions>
          </div>
          <div class="right fx-full">
            <div class="item">
              <span class="label">{{detailData.typeText}}评价：</span>
              <el-progress :percentage="data.score" :format="format" define-back-color="#ebeef5"></el-progress>
            </div>
            <!-- <div class="item"><span class="label">行业平均：</span>
              <el-progress :percentage="detailData.industryAverage" :format="format" define-back-color="#ebeef5"></el-progress>
            </div>
            <div class="item"><span class="label">地区平均：</span>
              <el-progress :percentage="detailData.originAverage" :format="format" define-back-color="#ebeef5"></el-progress>
            </div> -->
          </div>
        </div>
        <div class="tri">
          <div class="tri-box" v-for="(item,i) in detailData.subBlock" :key="i">
            <div class="tri-title">{{item.title}}</div>
            <div class="tir-li" v-for="(it,j) in item.children" :key="j">
              <img src="@/assets/panel/dot.png" />{{it}}
            </div>
            <emptyBox v-if="!item.children.length" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EnterpriseSub',
  components: {

  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {

    }
  },
  computed: {
    detailData() {
      return this.data?.detail || {}
    },
    imgField() { return this.detailData.imgField || '1' },
    tips() { return this.detailData.tips || '--' },
  },
  methods: {
    format(percentage) {
      return percentage + `分`;
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-table-emptyImg .empty {
  width: 60px;
  height: 60px;
  margin: 0;
}
.itemized-panel {
  width: 100%;
  margin-bottom: 12px;
  position: relative;
  .bg {
    position: absolute;
    right: 0;
    width: 80px;
  }
  .card {
    background: linear-gradient(180deg, #f6f8ff, #fff);
    border-radius: 4px;
    padding: 16px;
    .title {
      font-size: 14px;
      font-weight: 600;
      color: #586474;
      margin-bottom: 12px;
      img {
        width: 20px;
        margin-right: 4px;
        vertical-align: middle;
      }
    }
    .main {
      padding: 0 8px;
      .desc {
        margin-bottom: 16px;
        font-size: 12px;
        font-weight: 400;
        color: #586474;
        line-height: 17px;
        min-height: 34px;
      }
      ::v-deep.yellow {
        color: #f49000;
      }
      ::v-deep.jg {
        display: flex;
        font-size: 14px;
        margin-bottom: 18px;
        .left {
          width: 201px;
          .label {
            font-weight: 400;
            color: #86909c;
          }
          .el-descriptions__body {
            background-color: transparent;
          }
          .el-descriptions-item__cell {
            padding-bottom: 10px;
            line-height: normal;
          }
          .value {
            font-weight: 500;
            color: #f49000;
          }
        }
        .right {
          .item {
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            .el-progress {
              flex: 1;
            }
          }
        }
        .el-progress-bar__inner {
          background-color: unset;
          background-image: linear-gradient(90deg, #81aefd, #186bfc);
        }
      }
    }
  }
}

.tri {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.tri .tri-box {
  flex: 1;
  padding: 12px 16px;
  background: linear-gradient(180deg, #f4f8ff, #fbffff);
  border-radius: 4px;
  color: #586474;
}

.tri .tri-box .tri-title {
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 4px;
}

.tri .tri-box .tir-li {
  display: flex;
  line-height: 17px;
  margin: 9px 0;
  font-size: 0.8571428571rem;
  font-weight: 400;
}

.tri .tri-box .tir-li img {
  margin-top: 4px;
  margin-right: 3px;
  width: 8px;
  height: 8px;
}

.tri .tri-box .tri-empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-weight: 400;
  font-size: 0.8571428571rem;
  color: #86909c;
  align-items: center;
}

.tri .tri-box .tri-empty img {
  width: 106px;
}
</style>
